'use client';

import { createContext } from 'react';
import type { Device } from '../../utils/types';

export const DeviceHeaderContext = createContext<Device | null>(null);
